// extracted by mini-css-extract-plugin
export default {"container":"iphone_container__CFWAI","buttons":"iphone_buttons__mC2rn","button":"iphone_button__KCgyT","appStore":"iphone_appStore__fMgll"};